import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

import { useStyles } from "../../../../../Components/CSS/FormStyle.css";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";

class AddFeeType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: { name: "", code: "", description: "" },
      loading: false,
      feeTypeError: "",
    };
  }

  componentDidMount() {
    if (this.props.editStatus) {
      this.setData(this.props.data);
    }
  }

  setData = (data) => {
    this.setState({
      data: {
        name: data.name,
        code: data.code ? data.code : "",
        description: data.description ? data.description : "",
      },
    });
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  filterData = (data) => {
    let changedData = { ...data };
    if (!data.code) {
      delete changedData.code;
    }
    if (!data.description) {
      delete changedData.description;
    }
    return changedData;
  };

  checkError = (feeType) => {
    let feeTypeError = feeType ? feeType : "";
    if (feeTypeError) {
      this.setState({ feeTypeError });
      return true;
    } else {
      this.setState({ feeTypeError: "" });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        let data = this.filterData(this.state.data);

        if (this.props.editStatus) {
          const response = await Axios.put(
            `${url}/api/fee-types/${this.props.data._id}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${this.props.adminToken}`,
              },
            }
          );
          if (response.data.message === "Fee Type edited successfully") {
            this.props.handleCancelEdit();
            this.props.getFeeTypes();
          }
        } else {
          const response = await Axios.post(`${url}/api/fee-types`, data, {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          });
          if (response.data.message === "Fee Type added successfully") {
            this.setState({
              data: { name: "", code: "", description: "" },
              loading: false,
            });
            this.props.getFeeTypes();
          }
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data.message ===
          "Fee type with given name and code already saved"
        ) {
          console.clear();
          this.checkError(error.response.data.message);
        }
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <TableRow>
        <TableCell />
        <TableCell align="center">
          <TextField
            name="name"
            type="text"
            required
            variant="outlined"
            margin="normal"
            error={this.state.feeTypeError ? true : false}
            helperText={this.state.feeTypeError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.name}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name="code"
            type="text"
            label="(Optional)"
            variant="outlined"
            margin="normal"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.code}
            onChange={this.handleChange}
          />
        </TableCell>

        <TableCell align="center">
          <TextField
            name="description"
            label="(Optional)"
            type="text"
            multiline
            rows={4}
            rowsMax={8}
            variant="outlined"
            margin="normal"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.description}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          {this.props.editStatus ? (
            <>
              <Tooltip
                arrow
                title="Update"
                className={classes.tooltip}
                onClick={this.handleSubmit}
              >
                <CheckCircleIcon />
              </Tooltip>
              <Tooltip
                arrow
                title="Cancel"
                className={classes.tooltip}
                onClick={this.props.handleCancelEdit}
              >
                <CancelIcon />
              </Tooltip>
            </>
          ) : (
            <>
              <Tooltip
                arrow
                title="Add"
                className={classes.tooltip}
                onClick={this.handleSubmit}
              >
                <AddCircleIcon />
              </Tooltip>
            </>
          )}
          <br />
          {this.state.loading && <FormLoader />}
        </TableCell>
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(AddFeeType));
